/*! js/login/AngularLogin.30.1.2493.js © 2026 Open Education, LLC. */
webpackJsonp([15],{

/***/ 1867:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1868);


/***/ }),

/***/ 1868:
/***/ (function(module, exports, __webpack_require__) {

/*jslint browser: true, vars: true, plusplus: true, devel: true, nomen: true, indent: 4, maxerr: 50 */
/*global $, google, define, require, window */
(function () {
    'use strict';

    var $ = __webpack_require__(21),
        _ = __webpack_require__(20),
        Backbone = __webpack_require__(22),
        AngularOEPage = __webpack_require__(108),

        template = __webpack_require__(1869),
        templateFn = _.template(template);

    window.Login = Backbone.View.extend({

        render: function () {
            var me = this;
            this.$el.html(templateFn({
                i18n: i18n
            }));

            AngularOEPage.init();

            return this;
        }

    });
})();


/***/ }),

/***/ 1869:
/***/ (function(module, exports) {

module.exports = "<lp2-login-page></lp2-login-page>";

/***/ })

},[1867]);


// WEBPACK FOOTER //
// js/login/AngularLogin.30.1.2493.js